const LAST_SEEN_KEY_PREFIX = "veer-coach-leader-last-seen";

type LastSeenMap = Record<string, string>;

function buildLastSeenKey(coachId: string) {
  return `${LAST_SEEN_KEY_PREFIX}:${coachId}`;
}

export function getCoachLeaderLastSeenMap(coachId: string): LastSeenMap {
  try {
    const raw = localStorage.getItem(buildLastSeenKey(coachId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as LastSeenMap;
    if (!parsed || typeof parsed !== "object") return {};
    return parsed;
  } catch {
    return {};
  }
}

export function getCoachLeaderLastSeenAt(coachId: string, leaderId: string): string | null {
  const map = getCoachLeaderLastSeenMap(coachId);
  return map[leaderId] || null;
}

export function markCoachLeaderSeenNow(coachId: string, leaderId: string): string {
  const map = getCoachLeaderLastSeenMap(coachId);
  const iso = new Date().toISOString();
  map[leaderId] = iso;
  localStorage.setItem(buildLastSeenKey(coachId), JSON.stringify(map));
  return iso;
}

export function countItemsSince(
  createdAtValues: Array<string | null | undefined>,
  lastSeenAt: string | null
): number {
  if (!lastSeenAt) {
    return createdAtValues.filter(Boolean).length;
  }
  const threshold = new Date(lastSeenAt).getTime();
  if (Number.isNaN(threshold)) {
    return createdAtValues.filter(Boolean).length;
  }
  return createdAtValues.filter((value) => {
    if (!value) return false;
    const ts = new Date(value).getTime();
    return !Number.isNaN(ts) && ts > threshold;
  }).length;
}
